import { transferIncAmountCountryWise } from "../constants/transfersAmount";

interface SearchCriteria {
  searchCriteria: {
    destination: {
      'Display Name #1': string;
    };
  };
}

export const roundPrice: any = (price: string, displayOnlyNumber?: boolean) => {
  let amount: number = Number(price);
  let [dollars, cent]: string[] = String(price).split(".");
  const cents = Number(cent);

  if (dollars !== "undefined") {
    const lastDigit = Number(dollars?.charAt(dollars.length - 1));

    if (lastDigit < 5) {
      for (let i = lastDigit; i < 5; i++) {
        amount++;
      }
    } else if (lastDigit === 5 && !Boolean(cents)) {
      amount = Number(dollars);
    } else if (lastDigit === 9 && Boolean(cents)) {
      for (let i = lastDigit; i < lastDigit + 6; i++) {
        amount++;
      }
    } else if ((lastDigit === 5 && cents !== 0) || lastDigit > 5) {
      for (let i = lastDigit; i < 9; i++) {
        amount++;
      }
    } else {
      // console.log({ lastDigit }, { cents }, { price }, 'invalid');
    }
    let [newAmount] = String(amount).split(".");
    return displayOnlyNumber
      ? Number(newAmount)
      : String(Number(newAmount).toFixed(0));
  }
};

export const roundPriceTransfers = (price: string | number, isAdded: boolean | undefined, totalGuest: number, flighRoom: SearchCriteria, exchangeRate: string) => {
  const priceString = typeof price === 'string' ? price : price.toString();
  const value = parseFloat(priceString)

  if (isAdded) {
    const today = new Date();

    const filterTransfer = transferIncAmountCountryWise.filter((t) => {
      return flighRoom.searchCriteria.destination["Display Name #1"].toLowerCase().includes(t.country.toLowerCase().split(" &")[0])
    })

    const getCountryDetails = filterTransfer.filter((f) => today >= new Date(f.dateFrom) && today <= new Date(f.dateTo))

    if (value !== 0 && getCountryDetails.length > 0) {
      // const addAmount = getCountryDetails[0].fXYQ * parseFloat(exchangeRate)
      const addAmount = getCountryDetails[0].fXYQ 
      return value + (addAmount * totalGuest)  // for all passengers
    } else {
      return value
    }
  } else {
    return value
  }
}
